<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import CustomersAbc from './customers/customers-abc.svelte'
    import CustomersAll from './customers/customers-all.svelte'
    import CustomersPdv from './customers/customers-pdv.svelte'
    import CustomersBorn from './customers/customers-born.svelte'
    import CustomersSchedule from './customers/customers-schedule.svelte'
    import ReportsHome from './reports-home.svelte'
    import CustomersReferral from './customers/customers-referral.svelte'
    import CustomersCredit from './customers/customers-credit.svelte'
    import CustomersDebit from './customers/customers-debit.svelte'
    import CustomersBalance from './customers/customers-balance.svelte'
    import CustomersInconsistentBalance from './customers/customers-inconsistent-balance.svelte'
    import CustomersPdvItem from './customers/customers-pdv-item.svelte'
    import CustomersScheduleByAttendant from './customers/customers-schedule-by-attendant.svelte'
    import Ztab from '../_common/z/ztab.svelte'
    import PosSellerAndPm from './pos/pos-seller-and-pm.svelte'
    import SalesByPeriod from './sales/sales-by-period.svelte'
    import SalesByService from './sales/sales-by-service.svelte'
    import SalesBySeller from './sales/sales-by-seller.svelte'
    import SalesByServiceAbc from './sales/sales-by-service-abc.svelte'
    import SalesAvgTicketPerUnit from './sales/sales-avg-ticket-per-unit.svelte'
    import SalesAvgTicketPerSale from './sales/sales-avg-ticket-per-sale.svelte'
    import ScheduleOccupancyRate from './schedule/schedule-occupancy-rate.svelte'
    import ScheduleNoShowsList from './schedule/schedule-no-shows-list.svelte'
    import ScheduleNoShowsSummary from './schedule/schedule-no-shows-summary.svelte'
    import ScheduleAppointmentsByService from './schedule/schedule-appointments-by-service.svelte'
    import ScheduleAppointmentsByReferral from './schedule/schedule-appointments-by-referral.svelte'
    import ScheduleAppointmentsByAttendant from './schedule/schedule-appointments-by-attendant.svelte'
    import ScheduleAppointmentsBySchedule from './schedule/schedule-appointments-by-schedule.svelte'

    interface ReportItem {
        category: string
        label: string
        path: string
        component: any
    }

    // Cada relatório novo entra aqui como um item — o menu lateral e as rotas são gerados a partir desta lista.
    const reportsList: ReportItem[] = [
        { category: 'Pessoas', label: 'Cadastradas por período', path: '/customers-all', component: CustomersAll },
        { category: 'Pessoas', label: 'Compraram por período', path: '/customers-pdv', component: CustomersPdv },
        { category: 'Pessoas', label: 'Compraram por período e item', path: '/customers-pdv-item', component: CustomersPdvItem },
        { category: 'Pessoas', label: 'Agendadas por período', path: '/customers-schedule', component: CustomersSchedule },
        {
            category: 'Pessoas',
            label: 'Agendadas por período e atendente',
            path: '/customers-schedule-attendant',
            component: CustomersScheduleByAttendant,
        },
        // { category: 'Pessoas', label: 'Pararam de frequentar (sumidos)', path: '/customers-born', component: CustomersBorn },
        // { category: 'Pessoas', label: 'Abandonaram após uma falta', path: '/customers-born', component: CustomersBorn },
        { category: 'Pessoas', label: 'Aniversariantes', path: '/customers-born', component: CustomersBorn },
        { category: 'Pessoas', label: 'Curva ABC', path: '/customers-abc', component: CustomersAbc },
        { category: 'Pessoas', label: 'Com saldo de serviços', path: '/customers-balance', component: CustomersBalance },
        {
            category: 'Pessoas',
            label: 'Com saldo inconsistente de serviços',
            path: '/customers-inconsistent-balance',
            component: CustomersInconsistentBalance,
        },
        { category: 'Pessoas', label: 'Com crédito (financeiro)', path: '/customers-credit', component: CustomersCredit },
        { category: 'Pessoas', label: 'Em débito (financeiro)', path: '/customers-debit', component: CustomersDebit },
        // { category: 'Pessoas', label: 'Responderam NPS', path: '/customers-abc', component: CustomersAbc },
        { category: 'Pessoas', label: 'Pela origem', path: '/customers-referral', component: CustomersReferral },
        { category: 'Pessoas', label: 'Faltas e cancelamentos', path: '/schedule-no-shows-list', component: ScheduleNoShowsList },
        { category: 'Vendas', label: 'Por Meios de Pagamento', path: '/pos-seller-and-pm', component: PosSellerAndPm },
        { category: 'Vendas', label: 'Por período', path: '/sales-by-period', component: SalesByPeriod },
        { category: 'Vendas', label: 'Por serviço', path: '/sales-by-service', component: SalesByService },
        { category: 'Vendas', label: 'Por vendedor', path: '/sales-by-seller', component: SalesBySeller },
        { category: 'Vendas', label: 'Curva ABC por serviço', path: '/sales-by-service-abc', component: SalesByServiceAbc },
        { category: 'Vendas', label: 'Ticket médio por serviço (por unidade)', path: '/sales-avg-ticket-per-unit', component: SalesAvgTicketPerUnit },
        { category: 'Vendas', label: 'Ticket médio por serviço (por venda)', path: '/sales-avg-ticket-per-sale', component: SalesAvgTicketPerSale },
        { category: 'Agenda e atendimento', label: 'Taxa de ocupação', path: '/schedule-occupancy-rate', component: ScheduleOccupancyRate },
        {
            category: 'Agenda e atendimento',
            label: 'Faltas e cancelamentos',
            path: '/schedule-no-shows-summary',
            component: ScheduleNoShowsSummary,
        },
        {
            category: 'Agenda e atendimento',
            label: 'Atendimentos por serviço',
            path: '/schedule-appointments-by-service',
            component: ScheduleAppointmentsByService,
        },
        {
            category: 'Agenda e atendimento',
            label: 'Atendimentos por origem do cliente',
            path: '/schedule-appointments-by-referral',
            component: ScheduleAppointmentsByReferral,
        },
        {
            category: 'Agenda e atendimento',
            label: 'Atendimentos por profissional',
            path: '/schedule-appointments-by-attendant',
            component: ScheduleAppointmentsByAttendant,
        },
        {
            category: 'Agenda e atendimento',
            label: 'Atendimentos por agenda',
            path: '/schedule-appointments-by-schedule',
            component: ScheduleAppointmentsBySchedule,
        },
    ]

    const categories = [...new Set(reportsList.map((el) => el.category))]

    let showList = true
    function toggleList() {
        showList = !showList
    }

    let tabs = []
    tabs.push({ title: 'Relatórios', url: '/reports/home' })
</script>

<Content>
    <div class="root-report m-bottom-sm">
        <Ztab active="Relatórios" class="h-space" {tabs}></Ztab>
        <div class="report-body">
            <div class="list-outer h-print" class:no-show={!showList}>
                <div class="list scroll-dark">
                    {#each categories as category}
                        <div class="subtitle">{category}</div>
                        {#each reportsList.filter((el) => el.category === category) as report}
                            <Link class="link" href="/reports{report.path}">● {report.label}</Link>
                        {/each}
                    {/each}
                </div>

                <div class="list-hide" on:click={toggleList}>
                    {#if showList}
                        <Fa icon={faAngleDoubleLeft} />
                    {:else}
                        <Fa icon={faAngleDoubleRight} />
                    {/if}
                </div>
            </div>
            <div class="result">
                <Router>
                    <Route path="/home">
                        <ReportsHome />
                    </Route>
                    {#each reportsList as report}
                        <Route path={report.path}>
                            <svelte:component this={report.component} />
                        </Route>
                    {/each}
                </Router>
            </div>
        </div>
    </div>
</Content>

<style>
    .root-report {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 8px 16px;
        padding-top: 0px;
    }
    .tab {
        color: rgb(var(--audience-color));
        border-bottom-color: rgb(var(--audience-color));
        border-bottom-width: 2px;
    }
    .tab > :global(a) {
        background-color: rgba(var(--audience-color), 0.9) !important;
        color: white !important;
        text-shadow: 2px 2px 2px #333333ff !important;
        border-radius: 8px 8px 0px 0px !important;
    }
    .report-body {
        flex: 1 1 auto;
        padding: 0px 0px 16px 0px;
        display: flex;
        position: relative;
    }
    .report-body .list-outer {
        display: flex;
        background: #88888840;
        flex: 0 0 332px;
        max-height: calc(100vh - 120px);
    }
    .report-body .no-show {
        flex: 0 1 auto;
    }
    .report-body .no-show .list {
        display: none;
    }
    .report-body .list {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
    }
    .report-body .list-hide {
        flex: 0 0 8px;
        background: #99999910;
        font-size: 13px;
        padding: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .report-body .list .subtitle {
        padding-left: 4px;
        padding-top: 4px;
    }
    .report-body .list :global(a) {
        padding: 0px 4px 0px 12px;
        opacity: 0.9;
    }
    .report-body .list :global(a):hover {
        background: #88888830;
    }
    .report-body .result {
        flex: 1 1 auto;
        margin-left: 8px;
        max-width: 100%;
        overflow-x: hidden;
        padding-bottom: 100px;
    }
    .content :global(.is-active) {
        background-color: #99999907;
    }
</style>
